// eslint-disable-next-line import/no-unresolved
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";

import { GqlScalars } from "../types/scalars";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: GqlScalars["Date"]; output: GqlScalars["Date"] };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: GqlScalars["DateTime"]; output: GqlScalars["DateTime"] };
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: GqlScalars["UUID"]; output: GqlScalars["UUID"] };
};

/** An address object for querying */
export type Address = {
  __typename?: "Address";
  city: Scalars["String"]["output"];
  line1: Scalars["String"]["output"];
  line2?: Maybe<Scalars["String"]["output"]>;
  postcode: Scalars["String"]["output"];
};

/** An address */
export type AddressInput = {
  city: Scalars["String"]["input"];
  line1: Scalars["String"]["input"];
  line2?: InputMaybe<Scalars["String"]["input"]>;
  postcode: Scalars["String"]["input"];
};

/**
 * Details of user consent
 *
 * While consent is stored on Patient model in the database, semantically
 * it is a group of fields that is related to each other, hence it makes
 * sense to present it as an object in the GraphQL schema.
 */
export type Consent = {
  __typename?: "Consent";
  feedback: Scalars["Boolean"]["output"];
  history: Array<ConsentHistoryEntry>;
  privacyPolicy: Scalars["Boolean"]["output"];
  service: Scalars["Boolean"]["output"];
};

/**
 * Details of user consent
 *
 * While consent is stored on Patient model in the database, semantically
 * it is a group of fields that is related to each other, hence it makes
 * sense to present it as an object in the GraphQL schema.
 */
export type ConsenthistoryArgs = {
  keys?: InputMaybe<Array<ConsentType>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Details of changes to patient consent over time, including date and user performing
 * the change (which may not be available in case change is done in a migration).
 */
export type ConsentHistoryEntry = {
  __typename?: "ConsentHistoryEntry";
  changeDate: Scalars["DateTime"]["output"];
  changedBy?: Maybe<User>;
  feedback: Scalars["Boolean"]["output"];
  privacyPolicy: Scalars["Boolean"]["output"];
  service: Scalars["Boolean"]["output"];
};

export enum ConsentType {
  Feedback = "Feedback",
  PrivacyPolicy = "PrivacyPolicy",
  Service = "Service",
}

/** A contact detail object for querying */
export type ContactDetails = {
  __typename?: "ContactDetails";
  address: Address;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  preferredContactMethod: PreferredContactMethod;
  primaryContact: Scalars["String"]["output"];
  secondaryContact?: Maybe<Scalars["String"]["output"]>;
};

/** Contact details for a patient */
export type ContactDetailsInput = {
  address: AddressInput;
  email: Scalars["String"]["input"];
  preferredContactMethod: PreferredContactMethod;
  primaryContact: Scalars["String"]["input"];
  secondaryContact?: InputMaybe<Scalars["String"]["input"]>;
};

/** Create a hospital configuration */
export type CreateHospitalConfigResponse = {
  __typename?: "CreateHospitalConfigResponse";
  errors?: Maybe<Array<Error>>;
  hospitalConfig?: Maybe<HospitalConfiguration>;
};

export type CreatePatientInput = {
  consent: PatientConsentInput;
  contactDetails: ContactDetailsInput;
  dateOfBirth: Scalars["Date"]["input"];
  firstName: Scalars["String"]["input"];
  hospitalNumber: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  nhsNumber: Scalars["String"]["input"];
  oncologist?: InputMaybe<Scalars["String"]["input"]>;
  sex: Sex;
};

/** Create a Patient PDF and return URL to access it */
export type CreatePatientPDFResponse = {
  __typename?: "CreatePatientPDFResponse";
  errors?: Maybe<Array<Error>>;
  pdfUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Create a patient */
export type CreatePatientResponse = {
  __typename?: "CreatePatientResponse";
  errors?: Maybe<Array<Error>>;
  patient?: Maybe<Patient>;
};

export type CreateResultInput = {
  dateRecorded?: InputMaybe<Scalars["String"]["input"]>;
  haemoglobin: ResultDataInput;
  neutrophils: ResultDataInput;
  platelets: ResultDataInput;
  whiteBloodCells: ResultDataInput;
};

/** Create a Result */
export type CreateResultResponse = {
  __typename?: "CreateResultResponse";
  errors?: Maybe<Array<Error>>;
  result?: Maybe<ManualResult>;
};

export type CreateUserInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  roleId: Scalars["ID"]["input"];
};

/** Create a hospital user */
export type CreateUserResponse = {
  __typename?: "CreateUserResponse";
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** A device object for querying */
export type Device = {
  __typename?: "Device";
  id: Scalars["ID"]["output"];
};

/** Create Device Assign Request */
export type DeviceAssignResponse = {
  __typename?: "DeviceAssignResponse";
  errors?: Maybe<Array<Error>>;
  patient?: Maybe<Patient>;
};

/** Result Entered from Device */
export type DeviceResult = MeasurementToResultInterface & {
  __typename?: "DeviceResult";
  belowNeutrophilThreshold?: Maybe<Scalars["Boolean"]["output"]>;
  dateRecorded: Scalars["DateTime"]["output"];
  daysAgo?: Maybe<Scalars["Int"]["output"]>;
  device: Device;
  haemoglobin: ResultData;
  id: Scalars["ID"]["output"];
  neutrophils: ResultData;
  patient?: Maybe<Patient>;
  platelets: ResultData;
  whiteBloodCells: ResultData;
};

/** Withdraw Device Assign Request */
export type DeviceWithdrawResponse = {
  __typename?: "DeviceWithdrawResponse";
  errors?: Maybe<Array<Error>>;
  patient?: Maybe<Patient>;
};

/** Error type structure */
export type Error = {
  __typename?: "Error";
  extensions?: Maybe<ErrorExtensions>;
  message?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
};

export type ErrorExtensions = {
  __typename?: "ErrorExtensions";
  code?: Maybe<Scalars["String"]["output"]>;
};

/** Errors */
export type Errors = {
  __typename?: "Errors";
  errors: Array<Error>;
};

/** A Hospital Object for Querying */
export type Hospital = {
  __typename?: "Hospital";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  patients: Array<Patient>;
  roles: Array<Role>;
  users: Array<User>;
};

/** Hospital Config type structure */
export type HospitalConfiguration = {
  __typename?: "HospitalConfiguration";
  haemoglobinRangeFemale: Range;
  haemoglobinRangeMale: Range;
  id?: Maybe<Scalars["ID"]["output"]>;
  neutrophilRange: Range;
  neutrophilThreshold: Scalars["Float"]["output"];
  plateletRange: Range;
  wbcRange: Range;
};

/** Arguments required for creating a hospital configuration */
export type HospitalConfigurationInput = {
  haemoglobinRangeFemale: RangeInput;
  haemoglobinRangeMale: RangeInput;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  neutrophilRange: RangeInput;
  neutrophilThreshold: Scalars["Float"]["input"];
  plateletRange: RangeInput;
  wbcRange: RangeInput;
};

/** Result Entered Manually by HCP */
export type ManualResult = MeasurementToResultInterface & {
  __typename?: "ManualResult";
  belowNeutrophilThreshold?: Maybe<Scalars["Boolean"]["output"]>;
  dateRecorded: Scalars["DateTime"]["output"];
  daysAgo?: Maybe<Scalars["Int"]["output"]>;
  device: Device;
  enteredUser: User;
  haemoglobin: ResultData;
  id: Scalars["ID"]["output"];
  neutrophils: ResultData;
  patient?: Maybe<Patient>;
  platelets: ResultData;
  whiteBloodCells: ResultData;
};

export type MeasurementInterval = {
  __typename?: "MeasurementInterval";
  id: Scalars["UUID"]["output"];
  outOfRange: Scalars["Boolean"]["output"];
};

export type MeasurementIntervalInput = {
  id: Scalars["ID"]["input"];
  outOfRange: Scalars["Boolean"]["input"];
};

/** An interface for the Results Type */
export type MeasurementToResultInterface = {
  belowNeutrophilThreshold?: Maybe<Scalars["Boolean"]["output"]>;
  dateRecorded: Scalars["DateTime"]["output"];
  daysAgo?: Maybe<Scalars["Int"]["output"]>;
  device: Device;
  haemoglobin: ResultData;
  neutrophils: ResultData;
  platelets: ResultData;
  whiteBloodCells: ResultData;
};

/** Mutations Class */
export type Mutation = {
  __typename?: "Mutation";
  /** Create a hospital configuration */
  createHospitalConfig?: Maybe<CreateHospitalConfigResponse>;
  /** Create a patient */
  createPatient?: Maybe<CreatePatientResponse>;
  /** Create a Patient PDF and return URL to access it */
  createPatientPdf?: Maybe<CreatePatientPDFResponse>;
  /** Create a Result */
  createResult?: Maybe<CreateResultResponse>;
  /** Create a hospital user */
  createUser?: Maybe<CreateUserResponse>;
  /** Withdraw Device Assign Request */
  disEnrollPatient?: Maybe<DeviceWithdrawResponse>;
  /** Create Device Assign Request */
  enrollPatient?: Maybe<DeviceAssignResponse>;
  /** Edits a hospital configuration */
  updateHospitalConfig?: Maybe<UpdateHospitalConfigResponse>;
  /** Update a patient */
  updatePatient?: Maybe<UpdatePatientResponse>;
  /** Update a result */
  updateResult?: Maybe<UpdateResultResponse>;
  /** Update a hospital role */
  updateRole?: Maybe<UpdateRoleResponse>;
  /** Update a hospital user */
  updateUser?: Maybe<UpdateUserResponse>;
};

/** Mutations Class */
export type MutationcreateHospitalConfigArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  hospitalConfig: HospitalConfigurationInput;
};

/** Mutations Class */
export type MutationcreatePatientArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patient: CreatePatientInput;
};

/** Mutations Class */
export type MutationcreatePatientPdfArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
  results?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Mutations Class */
export type MutationcreateResultArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
  result: CreateResultInput;
};

/** Mutations Class */
export type MutationcreateUserArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  user: CreateUserInput;
};

/** Mutations Class */
export type MutationdisEnrollPatientArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
  withdrawalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Mutations Class */
export type MutationenrollPatientArgs = {
  allocationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
};

/** Mutations Class */
export type MutationupdateHospitalConfigArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  hospitalConfig: HospitalConfigurationInput;
};

/** Mutations Class */
export type MutationupdatePatientArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patient: UpdatePatientInput;
};

/** Mutations Class */
export type MutationupdateResultArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  result: UpdateResultInput;
};

/** Mutations Class */
export type MutationupdateRoleArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  role: RoleInput;
};

/** Mutations Class */
export type MutationupdateUserArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  user: UpdateUserInput;
};

/** A patient object for querying */
export type Patient = {
  __typename?: "Patient";
  consent: Consent;
  contactDetails: ContactDetails;
  dateOfBirth: Scalars["Date"]["output"];
  devices: Array<Device>;
  disEnrolledBy?: Maybe<User>;
  disEnrollmentDate?: Maybe<Scalars["DateTime"]["output"]>;
  enrolledBy?: Maybe<User>;
  enrollmentDate?: Maybe<Scalars["DateTime"]["output"]>;
  firstName: Scalars["String"]["output"];
  hospitalNumber: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  latestResult?: Maybe<TestResultType>;
  nhsNumber: Scalars["String"]["output"];
  oncologist?: Maybe<Scalars["String"]["output"]>;
  sex: Sex;
  testResults?: Maybe<Array<TestResultType>>;
  trainingDate?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Consents given by a patient */
export type PatientConsentInput = {
  feedback?: InputMaybe<Scalars["Boolean"]["input"]>;
  privacyPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
  service?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Arguments required for creating a patient */
export type PatientInput = {
  consent: PatientConsentInput;
  contactDetails: ContactDetailsInput;
  dateOfBirth: Scalars["Date"]["input"];
  firstName: Scalars["String"]["input"];
  hospitalNumber: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  lastName: Scalars["String"]["input"];
  nhsNumber: Scalars["String"]["input"];
  oncologist?: InputMaybe<Scalars["String"]["input"]>;
  preferredContactMethod: PreferredContactMethod;
  sex: Sex;
};

/** A permission object for querying */
export type Permission = {
  __typename?: "Permission";
  codename: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** A permission group object for querying */
export type PermissionGroup = {
  __typename?: "PermissionGroup";
  codename: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  permissions: Array<Permission>;
};

export enum PreferredContactMethod {
  Email = "Email",
  Phone = "Phone",
}

/** The possible queries exposed by the interface */
export type Query = {
  __typename?: "Query";
  currentUser: User;
  hospitalConfig?: Maybe<HospitalConfiguration>;
  patient?: Maybe<Patient>;
  patients?: Maybe<Array<Patient>>;
  permissionGroups: Array<PermissionGroup>;
  permissions: Array<Permission>;
  role: Role;
  roles: Array<Role>;
  user: User;
  users: Array<User>;
  validateHospitalConfig?: Maybe<Errors>;
  validatePatient?: Maybe<Errors>;
};

/** The possible queries exposed by the interface */
export type QuerypatientArgs = {
  id: Scalars["ID"]["input"];
};

/** The possible queries exposed by the interface */
export type QuerypatientsArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** The possible queries exposed by the interface */
export type QueryroleArgs = {
  id: Scalars["ID"]["input"];
};

/** The possible queries exposed by the interface */
export type QueryuserArgs = {
  id: Scalars["ID"]["input"];
};

/** The possible queries exposed by the interface */
export type QueryvalidateHospitalConfigArgs = {
  hospitalConfig?: InputMaybe<HospitalConfigurationInput>;
};

/** The possible queries exposed by the interface */
export type QueryvalidatePatientArgs = {
  patient?: InputMaybe<PatientInput>;
};

/** Range */
export type Range = {
  __typename?: "Range";
  max: Scalars["Float"]["output"];
  min: Scalars["Float"]["output"];
};

export type RangeInput = {
  max: Scalars["Float"]["input"];
  min: Scalars["Float"]["input"];
};

/** Results Data Type */
export type ResultData = {
  __typename?: "ResultData";
  id: Scalars["UUID"]["output"];
  measurementInterval: MeasurementInterval;
  unit: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type ResultDataInput = {
  measurementInterval?: InputMaybe<MeasurementIntervalInput>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
  value: Scalars["String"]["input"];
};

/** A role object for querying */
export type Role = {
  __typename?: "Role";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  permissionGroups: Array<PermissionGroup>;
  permissions: Array<Permission>;
};

export type RoleInput = {
  description: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  permissionGroups: Array<Scalars["ID"]["input"]>;
};

export enum Sex {
  Female = "Female",
  Male = "Male",
}

/** Union of Manual and Device Results */
export type TestResultType = DeviceResult | ManualResult;

/** Edits a hospital configuration */
export type UpdateHospitalConfigResponse = {
  __typename?: "UpdateHospitalConfigResponse";
  errors?: Maybe<Array<Error>>;
  hospitalConfig?: Maybe<HospitalConfiguration>;
};

export type UpdatePatientInput = {
  consent?: InputMaybe<PatientConsentInput>;
  contactDetails: ContactDetailsInput;
  dateOfBirth: Scalars["Date"]["input"];
  firstName: Scalars["String"]["input"];
  hospitalNumber: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  lastName: Scalars["String"]["input"];
  nhsNumber: Scalars["String"]["input"];
  oncologist?: InputMaybe<Scalars["String"]["input"]>;
  sex: Sex;
};

/** Update a patient */
export type UpdatePatientResponse = {
  __typename?: "UpdatePatientResponse";
  errors?: Maybe<Array<Error>>;
  patient?: Maybe<Patient>;
};

export type UpdateResultInput = {
  dateRecorded?: InputMaybe<Scalars["String"]["input"]>;
  haemoglobin: ResultDataInput;
  id: Scalars["ID"]["input"];
  neutrophils: ResultDataInput;
  platelets: ResultDataInput;
  whiteBloodCells: ResultDataInput;
};

/** Update a result */
export type UpdateResultResponse = {
  __typename?: "UpdateResultResponse";
  errors?: Maybe<Array<Error>>;
  result?: Maybe<ManualResult>;
};

/** Update a hospital role */
export type UpdateRoleResponse = {
  __typename?: "UpdateRoleResponse";
  errors?: Maybe<Array<Error>>;
  role?: Maybe<Role>;
};

export type UpdateUserInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  lastName: Scalars["String"]["input"];
  roleId: Scalars["ID"]["input"];
};

/** Update a hospital user */
export type UpdateUserResponse = {
  __typename?: "UpdateUserResponse";
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** A user object for querying */
export type User = {
  __typename?: "User";
  dateJoined: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  hospital?: Maybe<Hospital>;
  id: Scalars["ID"]["output"];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars["Boolean"]["output"];
  lastLogin?: Maybe<Scalars["DateTime"]["output"]>;
  lastName: Scalars["String"]["output"];
  role?: Maybe<Role>;
  roleId: Scalars["ID"]["output"];
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = { __typename?: "Query" } & {
  currentUser: { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName" | "email"> & {
      hospital?: Maybe<{ __typename?: "Hospital" } & Pick<Hospital, "id" | "name">>;
      role?: Maybe<
        { __typename?: "Role" } & Pick<Role, "name" | "description" | "id"> & {
            permissions: Array<{ __typename?: "Permission" } & Pick<Permission, "id" | "name" | "codename">>;
          }
      >;
    };
};

export type CreateHospitalConfigMutationVariables = Exact<{
  hospitalConfig: HospitalConfigurationInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateHospitalConfigMutation = { __typename?: "Mutation" } & {
  createHospitalConfig?: Maybe<
    { __typename?: "CreateHospitalConfigResponse" } & {
      hospitalConfig?: Maybe<
        { __typename?: "HospitalConfiguration" } & Pick<HospitalConfiguration, "id" | "neutrophilThreshold"> & {
            wbcRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            neutrophilRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            haemoglobinRangeMale: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            haemoglobinRangeFemale: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            plateletRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type GetHospitalConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetHospitalConfigQuery = { __typename?: "Query" } & {
  hospitalConfig?: Maybe<
    { __typename?: "HospitalConfiguration" } & Pick<HospitalConfiguration, "id" | "neutrophilThreshold"> & {
        wbcRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
        neutrophilRange: { __typename?: "Range" } & Pick<Range, "min" | "max">;
        haemoglobinRangeMale: { __typename?: "Range" } & Pick<Range, "min" | "max">;
        haemoglobinRangeFemale: { __typename?: "Range" } & Pick<Range, "min" | "max">;
        plateletRange: { __typename?: "Range" } & Pick<Range, "min" | "max">;
      }
  >;
};

export type UpdateHospitalConfigMutationVariables = Exact<{
  hospitalConfig: HospitalConfigurationInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateHospitalConfigMutation = { __typename?: "Mutation" } & {
  updateHospitalConfig?: Maybe<
    { __typename?: "UpdateHospitalConfigResponse" } & {
      hospitalConfig?: Maybe<
        { __typename?: "HospitalConfiguration" } & Pick<HospitalConfiguration, "id" | "neutrophilThreshold"> & {
            wbcRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            neutrophilRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            haemoglobinRangeMale: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            haemoglobinRangeFemale: { __typename?: "Range" } & Pick<Range, "max" | "min">;
            plateletRange: { __typename?: "Range" } & Pick<Range, "max" | "min">;
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type CreatePatientMutationVariables = Exact<{
  patient: CreatePatientInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreatePatientMutation = { __typename?: "Mutation" } & {
  createPatient?: Maybe<
    { __typename?: "CreatePatientResponse" } & {
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
      patient?: Maybe<{ __typename?: "Patient" } & Pick<Patient, "id">>;
    }
  >;
};

export type CreatePatientPdfMutationVariables = Exact<{
  patientId: Scalars["String"]["input"];
  results?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreatePatientPdfMutation = { __typename?: "Mutation" } & {
  createPatientPdf?: Maybe<
    { __typename?: "CreatePatientPDFResponse" } & Pick<CreatePatientPDFResponse, "pdfUrl"> & {
        errors?: Maybe<
          Array<
            { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
                extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
              }
          >
        >;
      }
  >;
};

export type CreateResultMutationVariables = Exact<{
  patientId: Scalars["String"]["input"];
  result: CreateResultInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateResultMutation = { __typename?: "Mutation" } & {
  createResult?: Maybe<
    { __typename?: "CreateResultResponse" } & {
      result?: Maybe<
        { __typename?: "ManualResult" } & Pick<
          ManualResult,
          "id" | "belowNeutrophilThreshold" | "dateRecorded" | "daysAgo"
        > & {
            whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type DisEnrollPatientMutationVariables = Exact<{
  withdrawalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
}>;

export type DisEnrollPatientMutation = { __typename?: "Mutation" } & {
  disEnrollPatient?: Maybe<
    { __typename?: "DeviceWithdrawResponse" } & {
      patient?: Maybe<
        { __typename?: "Patient" } & Pick<
          Patient,
          "id" | "firstName" | "lastName" | "dateOfBirth" | "hospitalNumber" | "sex" | "nhsNumber" | "oncologist"
        > & {
            contactDetails: { __typename?: "ContactDetails" } & Pick<
              ContactDetails,
              "primaryContact" | "secondaryContact"
            > & { address: { __typename?: "Address" } & Pick<Address, "line1" | "line2" | "city" | "postcode"> };
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type EnrollPatientMutationVariables = Exact<{
  allocationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  patientId: Scalars["String"]["input"];
}>;

export type EnrollPatientMutation = { __typename?: "Mutation" } & {
  enrollPatient?: Maybe<
    { __typename?: "DeviceAssignResponse" } & {
      patient?: Maybe<
        { __typename?: "Patient" } & Pick<
          Patient,
          "id" | "firstName" | "lastName" | "dateOfBirth" | "hospitalNumber" | "sex" | "nhsNumber" | "oncologist"
        > & {
            contactDetails: { __typename?: "ContactDetails" } & Pick<
              ContactDetails,
              "primaryContact" | "secondaryContact"
            > & { address: { __typename?: "Address" } & Pick<Address, "line1" | "line2" | "city" | "postcode"> };
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type GetPatientDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetPatientDetailsQuery = { __typename?: "Query" } & {
  patient?: Maybe<
    { __typename?: "Patient" } & Pick<
      Patient,
      "id" | "firstName" | "lastName" | "dateOfBirth" | "hospitalNumber" | "sex" | "nhsNumber" | "oncologist"
    > & {
        contactDetails: { __typename?: "ContactDetails" } & Pick<
          ContactDetails,
          "preferredContactMethod" | "primaryContact" | "secondaryContact" | "email"
        > & { address: { __typename?: "Address" } & Pick<Address, "line1" | "line2" | "city" | "postcode"> };
        consent: { __typename?: "Consent" } & Pick<Consent, "service" | "privacyPolicy" | "feedback"> & {
            serviceLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "service" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
            privacyPolicyLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "privacyPolicy" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
            feedbackLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "feedback" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
          };
      }
  >;
};

export type GetPatientResultsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetPatientResultsQuery = { __typename?: "Query" } & {
  patient?: Maybe<
    { __typename?: "Patient" } & Pick<
      Patient,
      | "id"
      | "firstName"
      | "lastName"
      | "dateOfBirth"
      | "hospitalNumber"
      | "sex"
      | "nhsNumber"
      | "oncologist"
      | "enrollmentDate"
      | "disEnrollmentDate"
      | "trainingDate"
    > & {
        enrolledBy?: Maybe<{ __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName">>;
        disEnrolledBy?: Maybe<{ __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName">>;
        testResults?: Maybe<
          Array<
            | ({ __typename: "DeviceResult" } & Pick<
                DeviceResult,
                "id" | "dateRecorded" | "belowNeutrophilThreshold"
              > & {
                  whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                })
            | ({ __typename: "ManualResult" } & Pick<
                ManualResult,
                "id" | "dateRecorded" | "belowNeutrophilThreshold"
              > & {
                  whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
                  neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
                  haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
                  platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
                  enteredUser: { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName">;
                })
          >
        >;
        contactDetails: { __typename?: "ContactDetails" } & Pick<
          ContactDetails,
          "id" | "primaryContact" | "secondaryContact" | "preferredContactMethod" | "email"
        > & { address: { __typename?: "Address" } & Pick<Address, "line1" | "line2" | "city" | "postcode"> };
        consent: { __typename?: "Consent" } & Pick<Consent, "service" | "privacyPolicy" | "feedback"> & {
            serviceLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "service" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
            privacyPolicyLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "privacyPolicy" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
            feedbackLastUpdate: Array<
              { __typename?: "ConsentHistoryEntry" } & Pick<ConsentHistoryEntry, "feedback" | "changeDate"> & {
                  changedBy?: Maybe<{ __typename?: "User" } & Pick<User, "firstName" | "lastName">>;
                }
            >;
          };
      }
  >;
};

export type GetPatientsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPatientsQuery = { __typename?: "Query" } & {
  patients?: Maybe<
    Array<
      { __typename?: "Patient" } & Pick<
        Patient,
        "id" | "firstName" | "lastName" | "hospitalNumber" | "nhsNumber" | "dateOfBirth" | "sex"
      > & {
          latestResult?: Maybe<
            | ({ __typename?: "DeviceResult" } & Pick<
                DeviceResult,
                "id" | "dateRecorded" | "belowNeutrophilThreshold" | "daysAgo"
              > & {
                  whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                })
            | ({ __typename?: "ManualResult" } & Pick<
                ManualResult,
                "id" | "dateRecorded" | "belowNeutrophilThreshold" | "daysAgo"
              > & {
                  whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                  platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value"> & {
                      measurementInterval: { __typename?: "MeasurementInterval" } & Pick<
                        MeasurementInterval,
                        "id" | "outOfRange"
                      >;
                    };
                })
          >;
        }
    >
  >;
};

export type UpdatePatientMutationVariables = Exact<{
  patient: UpdatePatientInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdatePatientMutation = { __typename?: "Mutation" } & {
  updatePatient?: Maybe<
    { __typename?: "UpdatePatientResponse" } & {
      patient?: Maybe<
        { __typename?: "Patient" } & Pick<
          Patient,
          "id" | "firstName" | "lastName" | "dateOfBirth" | "hospitalNumber" | "sex" | "nhsNumber" | "oncologist"
        > & {
            contactDetails: { __typename?: "ContactDetails" } & Pick<
              ContactDetails,
              "primaryContact" | "secondaryContact"
            > & { address: { __typename?: "Address" } & Pick<Address, "line1" | "line2" | "city" | "postcode"> };
            consent: { __typename?: "Consent" } & Pick<Consent, "service" | "privacyPolicy" | "feedback">;
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type UpdateResultMutationVariables = Exact<{
  result: UpdateResultInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateResultMutation = { __typename?: "Mutation" } & {
  updateResult?: Maybe<
    { __typename?: "UpdateResultResponse" } & {
      result?: Maybe<
        { __typename?: "ManualResult" } & Pick<
          ManualResult,
          "id" | "belowNeutrophilThreshold" | "dateRecorded" | "daysAgo"
        > & {
            whiteBloodCells: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            neutrophils: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            haemoglobin: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
            platelets: { __typename?: "ResultData" } & Pick<ResultData, "unit" | "value">;
          }
      >;
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
    }
  >;
};

export type GetPermissionGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermissionGroupsQuery = { __typename?: "Query" } & {
  permissionGroups: Array<{ __typename?: "PermissionGroup" } & Pick<PermissionGroup, "id" | "description">>;
};

export type GetRoleDetailsQueryVariables = Exact<{
  roleId: Scalars["ID"]["input"];
}>;

export type GetRoleDetailsQuery = { __typename?: "Query" } & {
  role: { __typename?: "Role" } & Pick<Role, "id" | "name" | "description"> & {
      permissionGroups: Array<
        { __typename?: "PermissionGroup" } & Pick<PermissionGroup, "id" | "description" | "codename">
      >;
    };
};

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = { __typename?: "Query" } & {
  roles: Array<{ __typename?: "Role" } & Pick<Role, "id" | "name" | "description">>;
};

export type UpdateRoleMutationVariables = Exact<{
  role: RoleInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateRoleMutation = { __typename?: "Mutation" } & {
  updateRole?: Maybe<
    { __typename?: "UpdateRoleResponse" } & {
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
      role?: Maybe<
        { __typename?: "Role" } & Pick<Role, "id" | "name" | "description"> & {
            permissionGroups: Array<
              { __typename?: "PermissionGroup" } & Pick<PermissionGroup, "id" | "description" | "codename">
            >;
          }
      >;
    }
  >;
};

export type CreateUserMutationVariables = Exact<{
  user: CreateUserInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateUserMutation = { __typename?: "Mutation" } & {
  createUser?: Maybe<
    { __typename?: "CreateUserResponse" } & {
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
      user?: Maybe<
        { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName" | "roleId" | "email"> & {
            role?: Maybe<{ __typename?: "Role" } & Pick<Role, "id" | "name" | "description">>;
          }
      >;
    }
  >;
};

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetUserDetailsQuery = { __typename?: "Query" } & {
  user: { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName" | "email" | "roleId">;
};

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersQuery = { __typename?: "Query" } & {
  users: Array<
    { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName" | "email" | "roleId"> & {
        role?: Maybe<{ __typename?: "Role" } & Pick<Role, "id" | "name" | "description">>;
      }
  >;
};

export type UpdateUserMutationVariables = Exact<{
  user: UpdateUserInput;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateUserMutation = { __typename?: "Mutation" } & {
  updateUser?: Maybe<
    { __typename?: "UpdateUserResponse" } & {
      errors?: Maybe<
        Array<
          { __typename?: "Error" } & Pick<Error, "path" | "message"> & {
              extensions?: Maybe<{ __typename?: "ErrorExtensions" } & Pick<ErrorExtensions, "code">>;
            }
        >
      >;
      user?: Maybe<
        { __typename?: "User" } & Pick<User, "id" | "firstName" | "lastName" | "roleId" | "email"> & {
            role?: Maybe<{ __typename?: "Role" } & Pick<Role, "id" | "name" | "description">>;
          }
      >;
    }
  >;
};

export const GetCurrentUser = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hospital" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "role" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "codename" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const CreateHospitalConfig = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateHospitalConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hospitalConfig" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "HospitalConfigurationInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createHospitalConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "hospitalConfig" },
                value: { kind: "Variable", name: { kind: "Name", value: "hospitalConfig" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hospitalConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wbcRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "neutrophilRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobinRangeMale" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobinRangeFemale" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plateletRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "neutrophilThreshold" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateHospitalConfigMutation, CreateHospitalConfigMutationVariables>;
export const GetHospitalConfig = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHospitalConfig" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hospitalConfig" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "wbcRange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "max" } },
                      { kind: "Field", name: { kind: "Name", value: "min" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutrophilRange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "min" } },
                      { kind: "Field", name: { kind: "Name", value: "max" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "haemoglobinRangeMale" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "min" } },
                      { kind: "Field", name: { kind: "Name", value: "max" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "haemoglobinRangeFemale" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "min" } },
                      { kind: "Field", name: { kind: "Name", value: "max" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plateletRange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "min" } },
                      { kind: "Field", name: { kind: "Name", value: "max" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "neutrophilThreshold" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHospitalConfigQuery, GetHospitalConfigQueryVariables>;
export const UpdateHospitalConfig = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateHospitalConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hospitalConfig" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "HospitalConfigurationInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHospitalConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "hospitalConfig" },
                value: { kind: "Variable", name: { kind: "Name", value: "hospitalConfig" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hospitalConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wbcRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "neutrophilRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobinRangeMale" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobinRangeFemale" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plateletRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "max" } },
                            { kind: "Field", name: { kind: "Name", value: "min" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "neutrophilThreshold" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateHospitalConfigMutation, UpdateHospitalConfigMutationVariables>;
export const CreatePatient = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patient" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreatePatientInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patient" },
                value: { kind: "Variable", name: { kind: "Name", value: "patient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePatientMutation, CreatePatientMutationVariables>;
export const CreatePatientPdf = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePatientPdf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "results" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPatientPdf" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "results" },
                value: { kind: "Variable", name: { kind: "Name", value: "results" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "pdfUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePatientPdfMutation, CreatePatientPdfMutationVariables>;
export const CreateResult = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "result" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateResultInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "result" },
                value: { kind: "Variable", name: { kind: "Name", value: "result" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "whiteBloodCells" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "neutrophils" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobin" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platelets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                      { kind: "Field", name: { kind: "Name", value: "daysAgo" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateResultMutation, CreateResultMutationVariables>;
export const DisEnrollPatient = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DisEnrollPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "withdrawalDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "disEnrollPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "withdrawalDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "withdrawalDate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                      { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "sex" } },
                      { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "oncologist" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "primaryContact" } },
                            { kind: "Field", name: { kind: "Name", value: "secondaryContact" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "line1" } },
                                  { kind: "Field", name: { kind: "Name", value: "line2" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "postcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisEnrollPatientMutation, DisEnrollPatientMutationVariables>;
export const EnrollPatient = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EnrollPatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "allocationDate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrollPatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "allocationDate" },
                value: { kind: "Variable", name: { kind: "Name", value: "allocationDate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "patientId" },
                value: { kind: "Variable", name: { kind: "Name", value: "patientId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                      { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "sex" } },
                      { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "oncologist" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "primaryContact" } },
                            { kind: "Field", name: { kind: "Name", value: "secondaryContact" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "line1" } },
                                  { kind: "Field", name: { kind: "Name", value: "line2" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "postcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnrollPatientMutation, EnrollPatientMutationVariables>;
export const GetPatientDetails = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                { kind: "Field", name: { kind: "Name", value: "sex" } },
                { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                { kind: "Field", name: { kind: "Name", value: "oncologist" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contactDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "preferredContactMethod" } },
                      { kind: "Field", name: { kind: "Name", value: "primaryContact" } },
                      { kind: "Field", name: { kind: "Name", value: "secondaryContact" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "line1" } },
                            { kind: "Field", name: { kind: "Name", value: "line2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "postcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "service" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "serviceLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "Service" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "service" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "privacyPolicy" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "privacyPolicyLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "PrivacyPolicy" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "privacyPolicy" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "feedback" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "feedbackLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "Feedback" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "feedback" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>;
export const GetPatientResults = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatientResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                { kind: "Field", name: { kind: "Name", value: "sex" } },
                { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                { kind: "Field", name: { kind: "Name", value: "oncologist" } },
                { kind: "Field", name: { kind: "Name", value: "enrollmentDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolledBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "disEnrollmentDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "disEnrolledBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "trainingDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "testResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ManualResult" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "whiteBloodCells" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "neutrophils" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "haemoglobin" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platelets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                            { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "enteredUser" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DeviceResult" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "whiteBloodCells" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "neutrophils" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "haemoglobin" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platelets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                            { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contactDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "primaryContact" } },
                      { kind: "Field", name: { kind: "Name", value: "secondaryContact" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredContactMethod" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "line1" } },
                            { kind: "Field", name: { kind: "Name", value: "line2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "postcode" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "service" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "serviceLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "Service" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "service" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "privacyPolicy" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "privacyPolicyLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "PrivacyPolicy" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "privacyPolicy" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "feedback" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "feedbackLastUpdate" },
                        name: { kind: "Name", value: "history" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "keys" },
                            value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "Feedback" }] },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "last" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConsentHistoryEntry" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "feedback" } },
                                  { kind: "Field", name: { kind: "Name", value: "changeDate" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "changedBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                        { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientResultsQuery, GetPatientResultsQueryVariables>;
export const GetPatients = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPatients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "patients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                { kind: "Field", name: { kind: "Name", value: "sex" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latestResult" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ManualResult" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "whiteBloodCells" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "neutrophils" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "haemoglobin" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platelets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                            { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                            { kind: "Field", name: { kind: "Name", value: "daysAgo" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DeviceResult" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "whiteBloodCells" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "neutrophils" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "haemoglobin" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "platelets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "unit" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "measurementInterval" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "outOfRange" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                            { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                            { kind: "Field", name: { kind: "Name", value: "daysAgo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientsQuery, GetPatientsQueryVariables>;
export const UpdatePatient = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePatient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "patient" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdatePatientInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePatient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "patient" },
                value: { kind: "Variable", name: { kind: "Name", value: "patient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "patient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                      { kind: "Field", name: { kind: "Name", value: "hospitalNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "sex" } },
                      { kind: "Field", name: { kind: "Name", value: "nhsNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "oncologist" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "primaryContact" } },
                            { kind: "Field", name: { kind: "Name", value: "secondaryContact" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "line1" } },
                                  { kind: "Field", name: { kind: "Name", value: "line2" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "postcode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "service" } },
                            { kind: "Field", name: { kind: "Name", value: "privacyPolicy" } },
                            { kind: "Field", name: { kind: "Name", value: "feedback" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const UpdateResult = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateResult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "result" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateResultInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateResult" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "result" },
                value: { kind: "Variable", name: { kind: "Name", value: "result" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "belowNeutrophilThreshold" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "whiteBloodCells" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "neutrophils" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "haemoglobin" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "platelets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "unit" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "dateRecorded" } },
                      { kind: "Field", name: { kind: "Name", value: "daysAgo" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateResultMutation, UpdateResultMutationVariables>;
export const GetPermissionGroups = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPermissionGroups" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "permissionGroups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPermissionGroupsQuery, GetPermissionGroupsQueryVariables>;
export const GetRoleDetails = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoleDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roleId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "role" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "roleId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissionGroups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "codename" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoleDetailsQuery, GetRoleDetailsQueryVariables>;
export const GetRoles = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRolesQuery, GetRolesQueryVariables>;
export const UpdateRole = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoleInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "role" },
                value: { kind: "Variable", name: { kind: "Name", value: "role" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "role" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissionGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "codename" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const CreateUser = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreateUserInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "user" },
                value: { kind: "Variable", name: { kind: "Name", value: "user" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "roleId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "role" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const GetUserDetails = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "roleId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetUsers = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "roleId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "role" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const UpdateUser = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UpdateUserInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "user" },
                value: { kind: "Variable", name: { kind: "Name", value: "user" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dryRun" },
                value: { kind: "Variable", name: { kind: "Name", value: "dryRun" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "extensions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "roleId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "role" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
